export default __webpack_public_path__ + "static/media/userInfo.6f6b5dbc.png";